import { createContext, useContext, useState, ReactNode } from "react";

interface QuizContextType {
  quizStarted: boolean;
  setQuizStarted: (started: boolean) => void;
}

const QuizContext = createContext<QuizContextType | undefined>(undefined);

export const QuizProvider = ({ children }: { children: ReactNode }) => {
  const [quizStarted, setQuizStarted] = useState(false);

  return (
    <QuizContext.Provider value={{ quizStarted, setQuizStarted }}>
      {children}
    </QuizContext.Provider>
  );
};

export const useQuiz = () => {
  const context = useContext(QuizContext);
  if (context === undefined) {
    throw new Error("useQuiz must be used within a QuizProvider");
  }
  return context;
};
